// Mock data for portfolio projects
export const mockPortfolioData = [
  {
    id: 1,
    title: 'Hiburan Seru (2025) by HS',
    category: 'photography',
    type: 'image',
    thumbnail: process.env.PUBLIC_URL + '/img/25.07.19_HS/HS0.jpg',
    images: [
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS1.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS2.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS3.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS4.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS5.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS6.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS7.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS8.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS9.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS10.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS11.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS12.jpg',
      process.env.PUBLIC_URL + '/img/25.07.19_HS/HS13.jpg'
    ],
    description: 'Hiburan Seru: Dokumentasi konser musik berbagai genre yang dibuat oleh HS. Mengabadikan momen panggung, interaksi penonton, dan energi musik secara dinamis dengan pendekatan storytelling yang hidup.'
  },
  {
    id: 2,
    title: 'JNE 2025',
    category: 'videography',
    type: 'video',
    thumbnail: process.env.PUBLIC_URL + '/vid/25.02.27_JNE/jne_thum2.png',
    video: 'https://www.youtube.com/embed/iSjoDBoN5co?autoplay=1&mute=1&loop=1&playlist=iSjoDBoN5co&modestbranding=1&controls=1&rel=0',
    description:
      'Video profil perusahaan yang menampilkan budaya kerja dan inovasi teknologi terdepan. Diproduksi dengan kualitas sinematik untuk meningkatkan brand awareness.',
  },

  {
    id: 3,
    title: 'Graduation UNEJ',
    category: 'photography',
    type: 'image',
    thumbnail: process.env.PUBLIC_URL + '/img/25.09.20_IC/IC0.jpg',
    images: [
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC1.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC2.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC3.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC4.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC5.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC6.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC7.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC8.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC9.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC10.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC11.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC12.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC13.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC14.jpg',
      process.env.PUBLIC_URL + '/img/25.09.20_IC/IC15.jpg'
    ],
    description: 'Dokumentasi momen wisuda mahasiswa Universitas Jember (UNEJ) dengan pendekatan profesional, menangkap kebahagiaan, ekspresi, dan momen penting secara natural dan elegan.'
  },
  {
    id: 4,
    title: 'Hiburan Seru (2025) by HS',
    category: 'videography',
    type: 'video',
    thumbnail: process.env.PUBLIC_URL + '/vid/25.08.02_HS/hs_thum.png',
    video: 'https://www.youtube.com/embed/eopkNABcazg?autoplay=1&mute=1&loop=1&playlist=eopkNABcazg&modestbranding=1&controls=1&rel=0',
    description:
      'Hiburan Seru: Dokumentasi konser musik berbagai genre yang dibuat oleh HS. Mengabadikan momen panggung, interaksi penonton, dan energi musik secara dinamis dengan pendekatan storytelling yang hidup.',
  },

  /* 
  {
    id: 5,
    title: 'Product Photography - Luxury Watch',
    category: 'photography',
    type: 'image',
    thumbnail: 'https://images.unsplash.com/photo-1524592094714-0f0654e20314?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1524592094714-0f0654e20314?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1547996160-81dfa63595aa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
    ],
    description: 'Fotografi produk dengan pencahayaan studio yang presisi untuk menampilkan detail dan kemewahan jam tangan premium. Setiap sudut dan refleksi diatur dengan sempurna.'
  },
  */
  {
    id: 6,
    title: 'Kinansyah Group - TVC',
    category: 'videography',
    type: 'video',
    thumbnail: process.env.PUBLIC_URL + '/vid/25.06.17_KN/kinansyah_thum.png',
    video: 'https://www.youtube.com/embed/eopkNABcazg',
    description: 'TVC perumahan Kinansyah Group yang menampilkan konsep hunian modern dan nyaman. Menekankan kualitas desain, fasilitas, dan gaya hidup yang ditawarkan, dikemas secara profesional dengan storytelling visual yang menarik.'
  },

  /* 
  {
    id: 7,
    title: 'Commercial Edit - Food Brand',
    category: 'editing',
    type: 'video',
    thumbnail: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    video: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4',
    description: 'Editing iklan komersial untuk brand makanan dengan pacing yang dinamis dan color grading yang menggugah selera. Focus pada visual yang appetizing dan branding yang kuat.'
  },
  */
  /*
  {
    id: 8,
    title: 'Portrait Session - Artist Series',
    category: 'photography',
    type: 'image',
    thumbnail: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
    ],
    description: 'Seri potret artistik dengan pencahayaan dramatis dan komposisi yang kuat. Menampilkan karakter dan kepribadian subjek melalui ekspresi dan gesture yang natural.'
  }
  */
];